import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as Actions from './actions';

const NewEventModalState = Record({
    isLoading: true,
    eventId: null,
    event: null,
    institutions: List(),
    recipients: List(),
    isVisible: false,
    isSubmitting: false,
    fetchingRecipients: false,
    isEditing: false,
});

export default handleActions(
    {
        [Actions.showAddNewEventModal.type]: (_, {payload}) => {
            return new NewEventModalState({
                eventId: payload.eventId,
                isVisible: true,
            });
        },

        [Actions.initialFetchSuccess.type]: (state, {payload}) => {
            return state.merge({
                isLoading: false,
                event: payload.event,
                institutions: List(payload.institutions),
                recipients: List(payload.recipients),
            });
        },

        [Actions.updateRecipients.type]: state => {
            return state.merge({
                fetchingRecipients: true,
            });
        },

        [Actions.updateRecipientsFailed.type]: state => {
            return state.merge({
                fetchingRecipients: false,
            });
        },

        [Actions.updateRecipientsSuccess.type]: (state, {payload}) => {
            return state.merge({
                fetchingRecipients: false,
                recipients: List(payload.recipients),
            });
        },

        [Actions.createEvent.type]: state =>
            state.merge({
                isSubmitting: true,
            }),
        [Actions.createEventFailed.type]: state =>
            state.merge({
                isSubmitting: false,
            }),
        [Actions.createEventSuccess.type]: () => new NewEventModalState(),

        [Actions.updateEvent.type]: state =>
            state.merge({
                isSubmitting: true,
            }),
        [Actions.updateEventFailed.type]: state =>
            state.merge({
                isSubmitting: false,
            }),
        [Actions.updateEventSuccess.type]: () => new NewEventModalState(),
        [Actions.hideNewEventModal.type]: () => new NewEventModalState(),
    },
    NewEventModalState(),
);
